<template>
    <div
        class="feedback"
        :class="{
            'is-login': optName,
        }"
    >
        <div @click="handleFeedback">
            <veui-icon ref="feedbackRef" name="file-edit"/>
            <veui-tooltip
                position="bottom"
                target="feedbackRef"
                ui="reverse"
                :hide-delay="100"
                overlay-class="feedback-overlay"
            >
                意见反馈
            </veui-tooltip>
        </div>
        <feedback-dialog :open.sync="openFeedback"/>

    </div>
</template>

<script>
import {Icon, Tooltip} from 'veui';
import FeedbackDialog from './FeedbackDialog.vue';
import 'veui-theme-dls-icons/file-edit';
export default {
    name: 'feedback',
    inject: ['alsLog'],
    components: {
        'veui-icon': Icon,
        'veui-tooltip': Tooltip,
        'feedback-dialog': FeedbackDialog
    },
    props: {
    },
    data() {
        return {
            openFeedback: false
        };
    },
    computed: {
        optName() {
            return this.$store.state.app.userInfo.accountInfo?.optName || '';
        }
    },
    methods: {
        handleFeedback() {
            this.openFeedback = true;
            this.alsLog({
                f1: 'qingduoFeedback',
                f2: 'click',
                f5: this.$route.name,
                f15: this.$route?.path
            });
        }
    },
    mounted() {
    // 组件挂载后执行的逻辑
    }
};
</script>

<style scoped lang="less">
.feedback {
        display: inline-block;
        width: 16px;
        height: 16px;
        cursor: pointer;
        display: none;
        &:hover {
            color: #545B66;
        }
        &.is-login {
            display: inline-block;
        }
}
.feedback-overlay {
    /deep/ .veui-tooltip {
        border-radius: var(--Radius-r1, 6px);
        background: var(----G9, #282C33);
        margin-top: 6px;
        padding: 0 8px;
        height: 25px;
    }
    /deep/ .veui-tooltip-content {
        margin: 0px;
        color: var(----G0, #FFF);
        display: inline-flex;
        height: 100%;
        align-items: center;
    }
    /deep/ .veui-tooltip-arrow {
        color: var(----G9, #282C33);
    }
}

</style>